const _excluded = ["value", "skin", "fitContent", "className"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React, { useEffect, useRef } from 'react';
import Quill from 'quill';
import cn from 'classnames';
import { applyValueToQuill, supportedFormats, theme } from "../RichTextEditor/RichTextEditor";
import editorStyles from "../RichTextEditor/RichTextEditor.module.scss";
import styles from "./RichTextViewer.module.scss";
export function RichTextViewer(props) {
  const {
      value = '',
      skin = 'standard',
      fitContent,
      className
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const editorRef = useRef(null);
  const quillRef = useRef();

  // Initialize Quill.
  useEffect(() => {
    if (!quillRef.current) {
      quillRef.current = new Quill(editorRef.current, {
        modules: {
          toolbar: false
        },
        theme,
        readOnly: true,
        formats: supportedFormats
      });
    }
  }, []);

  // Update Quill's contents when value changes.
  useEffect(() => {
    if (quillRef.current) {
      applyValueToQuill(quillRef.current, value);
    }
  }, [value]);
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: cn(editorStyles.root, styles.viewer, styles["".concat(skin, "Skin")], {
      [styles.fitContent]: fitContent
    }, className),
    ref: editorRef
  }));
}